import api from 'api/apiInstance';

export function syncTokensApi(path: string) {
  return {
    path,
    POST: () => api.post<{ token: string }>(path),
  };
}
